<template>
    <form-wizard
        color="#7367f0"
        :title="null"
        :subtitle="null"
        finish-button-text="Сохранить"
        next-button-text="Далее"
        back-button-text="Назад"
        class="steps-transparent"
        @on-complete="() => submitAction()"
    >
        <tab-content
        icon="feather icon-file-text"
        title="Общие"
        :before-change="()=> validateForm(steps['step_1'].value)"
    >
        <validation-observer
                ref="step_1"
                tag="form"
        >

            <b-form-group
                label="Номер"
                label-size="sm"
                class="flex-grow-1"
                description="Укажите номер"
            >
                <validation-provider
                        #default="{ errors }"
                        name="number"
                        rules="required"
                >
                    <b-form-input
                            class="w-100"
                            v-model="formModel['number']"
                            :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
            <b-form-group
                label="Тип обьекта"
                label-size="sm"
                class="flex-grow-1"
                description="Укажите тип обьекта"
            >
                <validation-provider
                        #default="{ errors }"
                        name="object_type"
                        rules="required"
                >
                    <choose-object-type-field
                            v-model="formModel['object_type']"
                            @input="val=>formModel['object_type']=val"
                    ></choose-object-type-field>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
        </validation-observer>
    </tab-content>
        <tab-content
                icon="feather icon-file-text"
                title="Платформа"
                :before-change="()=> validateForm(steps['step_2'].value)"
        >
            <validation-observer
                    ref="step_2"
                    tag="form"
            >
                <b-form-group
                    label="Платформа"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите платформу"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="platform"
                            rules="required"
                    >
                        <choose-platform-field
                                v-model="formModel['platform']"
                                @input="val=>formModel['platform']=val"
                        ></choose-platform-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
    </form-wizard>
</template>


<script>
    import {ref} from '@vue/composition-api'

    import {BContainer, BRow, BCol, BForm, BFormGroup, BFormInput, BFormCheckbox} from 'bootstrap-vue'

    import { FormWizard, TabContent } from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'

    import { STORE_MODULE_NAME } from '@/views/apps/railway_structure/shed/shedStoreModule'
    import useShed from '@/views/apps/railway_structure/shed/useShed'

    import { validateForm } from '@core/utils/validations/utils'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { required } from '@validations'


    import useAppElementListAddNew from "@core/components/app-elements/appElementListAddNew/useAppElementListAddNew";
    import ChooseUserField from "@/views/apps/user/components/ChooseUserField";
    import ChoosePlatformField from "@/views/apps/railway_structure/platform/components/ChoosePlatformField";
    import ChooseObjectTypeField from "@/views/apps/infrastructure/object_type/components/ChooseObjectTypeField";


    export default {

        components:{
            ChooseObjectTypeField,
            ChoosePlatformField,
            ChooseUserField,
            BContainer, BRow, BCol,
            FormWizard, TabContent,
            BForm, BFormGroup, BFormInput, BFormCheckbox,

            ValidationProvider, ValidationObserver
        },

        setup() {

            const {
                addDataUrl,
                setupData,
            } = useShed();

            const {
                formModel,
                submitAction,
            } = useAppElementListAddNew({
                storeModuleName: STORE_MODULE_NAME,
                addDataUrl: addDataUrl,
                ...setupData,
            })


            const steps = {
                step_1:ref(null),
                step_2:ref(null),
                step_3:ref(null),
            }


            return {
                submitAction,
                formModel,

                steps, ...steps,
                validateForm,
            }
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
</style>
